var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.888,
    height: 14.1,
    viewBox: "0 0 20.888 14.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_zocial-email",
    "data-name": "Icon zocial-email",
    d: "M.072,16.919V5.317q0-.02.06-.383l6.828,5.841L.153,17.322a1.707,1.707,0,0,1-.081-.4ZM.978,4.128a.868.868,0,0,1,.342-.06h18.39a1.141,1.141,0,0,1,.363.06L13.225,9.99l-.906.725-1.793,1.47-1.793-1.47L7.827,9.99ZM1,18.108l6.869-6.587,2.659,2.155,2.659-2.155,6.869,6.587a.967.967,0,0,1-.342.06H1.321A.912.912,0,0,1,1,18.108Zm13.093-7.332L20.9,4.934a1.2,1.2,0,0,1,.06.383v11.6a1.544,1.544,0,0,1-.06.4Z",
    transform: "translate(-0.072 -4.068)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialEmail);
export default __webpack_public_path__ + "static/media/social-email.79740979ef40e8c8aa3c458ab6aa059b.svg";
export { ForwardRef as ReactComponent };